import styled from "styled-components";
import { Drawer } from "vaul";
import { IoClose } from "react-icons/io5";

export const Overlay = styled(Drawer.Overlay)`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.192);
`;

export const Content = styled(Drawer.Content) <{
  width?: string;
  variant?: "filter" | "default";
}>`
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: ${(props) => props.width || "100%"};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 1.5rem;
  outline: none;
  max-height: 98vh;
  display: flex;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  flex: 1;
  overflow-y: scroll;
  scrollbar-gutter: stable;
`;

export const Trigger = styled(Drawer.Trigger)`
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  div {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  h2 {
    font-size: 18px;
  }
`;

export const HeaderTitle = styled(Drawer.Title)`
  font-size: ${(props) => props.theme.fontSize["XS"]};
  font-weight: ${(props) => props.theme.fontWeight["Semibold"]};
  color: ${(props) => props.theme.newColors["gray-900"]};
`;

export const Separator = styled.hr`
  border-top: 1px solid ${(props) => props.theme.colors["gray-100"]};
  margin-bottom: 1rem;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors?.["gray-850"] || "#333"};
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const CloseIcon = styled(IoClose)`
  color: ${({ theme }) => theme.colors?.["gray-850"] || "#333"};
`;
